import { gql } from "@apollo/client";
import { graph } from "config/axios-context";
import { 
    AgricultureMaintenaceLogTypeMutationDocument, 
    AgricultureMaintenaceLogTypeMutationMutation, 
    AgricultureMaintenaceLogTypeMutationMutationVariables, 
    AgricultureMaintenanceLogTypeItemDocument, 
    AgricultureMaintenanceLogTypeItemQuery, 
    AgricultureMaintenanceLogTypeItemQueryVariables, 
    AgricultureMaintenanceLogTypeListDocument, 
    AgricultureMaintenanceLogTypeListQuery, 
    AgricultureMaintenanceLogTypeListQueryVariables, 
    MaintenanceLogTypeInput,
    AgricultureMaintenaceLogTypeDeleteDocument,
    AgricultureMaintenaceLogTypeDeleteMutation,
    AgricultureMaintenaceLogTypeDeleteMutationVariables
} from "types/graphql";

const agricultureMaintenanceLogTypeListQuery = gql`
query AgricultureMaintenanceLogTypeList($where: MaintenanceLogTypeFilterInput, $order: [MaintenanceLogTypeSortInput!], $skip:Int, $take: Int) {
    maintenanceLogTypes {
        items(where: $where, order: $order, skip:$skip, take:$take) {
            id,
            name
        }
    }
}
`;

export async function getAgricultureMaintenanceLogTypeListQuery(params?: AgricultureMaintenanceLogTypeListQueryVariables) {
    try {
        const response = await graph<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>({
            query: AgricultureMaintenanceLogTypeListDocument,
            variables: params
        });

        if (response.errors) {
            throw response.errors;
        }

        return response;
    } catch (error) {
        throw error;
    }
}

 
const agricultureMaintenanceLogTypeItemQuery = gql`
query AgricultureMaintenanceLogTypeItem($where: MaintenanceLogTypeFilterInput, $id: Int) {
    maintenanceLogType(where: $where, id: $id) {
        id,
        name
    }
}
`;

export async function getAgricultureMaintenanceLogTypeItemQuery(params?: AgricultureMaintenanceLogTypeItemQueryVariables) {
    try {
        const response = await graph<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>({
            query: AgricultureMaintenanceLogTypeItemDocument,
            variables: params
        });

        if (response.errors) {
            throw response.errors;
        }

        return response;
    } catch (error) {
        throw error;
    }
}

 
const agricultureMaintenanceLogTypeMutationDocument = gql`
mutation AgricultureMaintenaceLogTypeMutation($model: MaintenanceLogTypeInput!) {
    maintenanceLogType(model: $model) {
      id
    }
  }
`;

export async function agricultureMaintenanceLogTypeMutation(model: MaintenanceLogTypeInput) {
    try {
        const response = await graph<AgricultureMaintenaceLogTypeMutationMutation, AgricultureMaintenaceLogTypeMutationMutationVariables>({
            query: AgricultureMaintenaceLogTypeMutationDocument,
            variables: {
                model
            }
        });

        if (response.errors) {
            throw response.errors;
        }

        return response;
    } catch (error) {
        throw error;
    }
}

 
const agricultureMaintenanceLogTypeDeleteMutationDocument = gql`
mutation AgricultureMaintenaceLogTypeDelete($where: MaintenanceLogTypeFilterInput, $id: Int) {
    maintenanceLogTypeDelete(id: $id, where: $where)
  }
  `

  
export async function agricultureMaintenanceLogTypeDeleteMutation(variables: AgricultureMaintenaceLogTypeDeleteMutationVariables) {
    try {
        const response = await graph<AgricultureMaintenaceLogTypeDeleteMutation, AgricultureMaintenaceLogTypeDeleteMutationVariables>({
            query: AgricultureMaintenaceLogTypeDeleteDocument,
            variables
        });

        if (response.errors) {
            throw response.errors;
        }

        return response;
    } catch (error) {
        throw error;
    }
}
